import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { TicketStatus as Status } from "entities/customerTickets/types";
import React, { FC } from "react";
import { COLOR_GREY_11 } from "shared/theme/colors";
import TicketStatus from "../../../../TicketStatus";
import { getMessageDate } from "modules/customerTickets/pages/CustomerTickets/helpers";

type Props = {
  status: Status;
  date: Date;
};

const TicketStatusInfo: FC<Props> = ({ status, date }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="end" rowGap="4px">
      <Typography variant="bodySRegular" color={COLOR_GREY_11}>
        {getMessageDate(date)}
      </Typography>
      <TicketStatus status={status} />
    </Box>
  );
};

export default TicketStatusInfo;
